import { useState } from "react";
import { Fingerprint, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import PasskeyList from "@/components/auth/passkey/PasskeyList";
import RegisterPasskeyModal from "@/components/auth/passkey/RegisterPasskeyModal";
import { isWebAuthnSupported } from "@/utils/webauthn";

/**
 * AccountSettings
 *
 * User account settings page. Currently contains the Passkeys section.
 * Add additional sections (profile, password change) here as needed.
 *
 * Route: /dashboard/account-settings (register in your router)
 */
export default function AccountSettings() {
    const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);

    return (
        <div className="min-h-screen bg-gray-50 p-6 sm:p-8 lg:p-10">
            <div className="mx-auto max-w-3xl space-y-8">

                {/* Page Header */}
                <div>
                    <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
                        Account Settings
                    </h1>
                    <p className="mt-1 text-sm text-gray-500">
                        Manage your account preferences and security settings.
                    </p>
                </div>

                {/* ------------------------------------------------------------------ */}
                {/* Passkeys Section                                                   */}
                {/* ------------------------------------------------------------------ */}
                {isWebAuthnSupported() && (
                    <section className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm">
                        {/* Section header */}
                        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-5">
                            <div className="flex items-center gap-3">
                                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-50">
                                    <Fingerprint className="h-5 w-5 text-[#2546A1]" />
                                </div>
                                <div>
                                    <h2 className="text-base font-bold text-gray-900">
                                        Passkeys
                                    </h2>
                                    <p className="text-xs text-gray-500">
                                        Manage your passwordless authentication
                                    </p>
                                </div>
                            </div>

                            <Button
                                type="button"
                                onClick={() => setIsRegisterModalOpen(true)}
                                className="flex items-center gap-2 rounded-full bg-[#2546A1] text-sm hover:bg-[#1e3a8a] cursor-pointer">
                                <KeyRound className="h-4 w-4" />
                                <span className="hidden sm:inline">Register new passkey</span>
                                <span className="sm:hidden">Add</span>
                            </Button>
                        </div>

                        {/* Passkey list */}
                        <div className="p-6">
                            <PasskeyList />
                        </div>
                    </section>
                )}

                {/* Placeholder: add more sections here (Profile, Password, etc.) */}
            </div>

            {/* Register Passkey Modal */}
            <RegisterPasskeyModal
                open={isRegisterModalOpen}
                onOpenChange={setIsRegisterModalOpen}
            />
        </div>
    );
}